import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchAll as fetchAllSprint } from '../sprint/actions';
import { fetchAll as fetchAllBypassed } from '../bypassed/actions';
import { fetchAll as fetchAllQuick } from '../quick/actions';
import { fetchFiltered as fetchInsuranceContracts } from 'insurance/insuranceContracts/actions';
import {
  getAllSprintSubscriptions,
  getAllBypassedSubscriptions,
  getAllQuickSubscriptions,
  getUser,
  getFilteredInsuranceContracts,
} from 'reducers';
import InsuranceSubscriptionList from './InsuranceSubscriptionList';
import * as routes from 'app/routes';
import { isMvno } from '../utils';

class SubscriptionListComponent extends Component {

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.userId !== oldProps.userId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { fetchAllSprint, fetchAllBypassed, fetchAllQuick, fetchInsuranceContracts, userId } = this.props;
    if (!userId) { return; }
    fetchAllSprint(userId);
    fetchAllBypassed(userId);
    fetchAllQuick(userId);
    fetchInsuranceContracts({ user_profile: userId });
  }

  render() {
    return <InsuranceSubscriptionList {...this.props} />
  }
}

const mapStateToProps = (state) => {
  const sprintSubs = getAllSprintSubscriptions(state);
  const bypassedSubs = getAllBypassedSubscriptions(state);
  const quickSubs = getAllQuickSubscriptions(state);

  const filteredSprintSubs = sprintSubs && sprintSubs.filter(sub => {
    const contracts = getFilteredInsuranceContracts(state, { subscription: sub.id });
    return (['active', 'suspended'].includes(sub.sprint_status)) && (!contracts || !contracts.length || !contracts.find(contract => contract.status === 'active'));
  });
  const filteredBypassedSubs = bypassedSubs && bypassedSubs.filter(sub => {
    if (!isMvno(sub)){
      return false;
    }

    const contracts = getFilteredInsuranceContracts(state, { bypassedSubscription: sub.id });
    return (['active', 'suspended'].includes(sub.bypassed_status)) && (!contracts || !contracts.length || !contracts.find(contract => contract.status === 'active'));
  });
  const filteredQuickSubs = quickSubs && quickSubs.filter(sub => {
    const contracts = getFilteredInsuranceContracts(state, { quickSubscription: sub.id });
    return (['active', 'suspended'].includes(sub.quick_status)) && (!contracts || !contracts.length || !contracts.find(contract => contract.status === 'active'));
  });

  return {
    userId: getUser(state) && getUser(state).id,
    sprintSubs: filteredSprintSubs,
    bypassedSubs: filteredBypassedSubs,
    quickSubs: filteredQuickSubs,
  }
};

const mapDispatchToProps = {
  fetchAllSprint,
  fetchAllBypassed,
  fetchAllQuick,
  fetchInsuranceContracts,
  onSprintClick: routes.sprintInsuranceDevice,
  onBypassedClick: routes.bypassedInsuranceDevice,
  onQuickClick: routes.quickInsuranceDevice,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionListComponent);
